import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API from "../api/axios";
import "../style/Category.css";

const CategoryPage = () => {
  const { name } = useParams(); // category name from URL
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await API.get("/products");

        // filter by category (case-insensitive)
        const filtered = res.data.filter(
          (p) => p.category && p.category.toLowerCase() === name.toLowerCase()
        );

        setProducts(filtered);
      } catch (err) {
        console.error("Failed to fetch products", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [name]);

  if (loading) return <p>Loading products...</p>;

  return (
    <div className="category-page">
      <h2>{name} Products</h2>

      <div className="product-list-category">
        {products.length > 0 ? (
          products.map((p) => {
            const hasDiscount =
              parseFloat(p.discount) > 0 &&
              (!p.discountExpiresAt ||
                new Date(p.discountExpiresAt) > new Date());

            return (
              <Link
                key={p._id}
                to={`/product/${p._id}`}
                className="product-card"
              >
                {hasDiscount && (
                  <span className="discount-badge">{p.discount}% OFF</span>
                )}
                <img src={p.image} alt={p.name} />
                <h3>{p.name}</h3>
                <p>₹{p.price}</p>
              </Link>
            );
          })
        ) : (
          <p className="no-results">No products found in this category.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
